import { DatePicker } from "antd";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import React, { useState } from "react";
import { Button, Dropdown, DropdownButton } from "react-bootstrap";
import { warehouseReport } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { isDownloadDisabled } from "modules/utilities/utility";

function WarehouseReport() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { fetchWarehouseReport } = warehouseReport();
  const { setToaster } = useToast();
  const handleItemSelected = (item) => {
    setSelectedItem(item);
  };

  const disabledEndDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const handleDownload = () => {
    let category
    if (selectedItem === "Stock not allocated report") {
      category = 'stock_not_allocated'
    } else if (selectedItem === "Stock not cancelled report") {
      category = 'stock_not_cancelled'
    } else {
      category = 'warehouse_order_assocation'
    }
    const payload = { startDate, endDate, category };
    fetchWarehouseReport(payload, setToaster);
  };
  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <DropdownButton
            id="dropdown-basic-button"
            title={selectedItem || "Select report"}
            variant="primary"
          >
            <Dropdown.Item
              onClick={() => handleItemSelected("Stock not allocated report")}
            >
              Stock not allocated report
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleItemSelected("Stock not cancelled report")}
            >
              Stock not cancelled report
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleItemSelected("Warehouse order association")}
            >
              Warehouse order association
            </Dropdown.Item>
          </DropdownButton>
          {selectedItem && (
            <div className="d-flex w-50 mt-2">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Start Date"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control ml-2"
                placeholderText="End Date"
                disabledDate={disabledEndDate}
              />
            </div>
          )}
        </div>
      }
      component={
        selectedItem && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>{selectedItem}</div>
            <Button variant="primary" onClick={handleDownload} disabled={isDownloadDisabled}>
              Download
            </Button>
          </div>
        )
      }
    />
  );
}

export default WarehouseReport;
